module.exports = __webpack_public_path__ + "img/shopping-cart.79cae82e.svg";